import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { cn } from '@/lib/utils'
import { SiteFooter } from '@/components/generals/site-footer'
import { SiteHeader } from '@/components/generals/site-header'

export const Layout: FC<LayoutProps> = ({ children, variant = 'default', categories = [] }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <SiteHeader categories={categories} overlay={variant === 'overlay'} />
            <main id='main' className={cn('flex-1', variant === 'default' && 'pt-[72px] lg:pt-[84px]')}>
                {children}
            </main>
            <SiteFooter categories={categories} />
        </div>
    )
}
